// components/Modals/CircleModal.js
import React from "react";
import { Modal } from "react-bootstrap";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import Button from "react-bootstrap/Button";

const CircleModal = ({
  show,
  onClose,
  selectedCircle,
  divisionData,
  onDivisionClick,
  formatAmount,
}) => {
  const handleBarClick = (data) => {
    if (data?.activeLabel) {
      onDivisionClick(data.activeLabel);
    }
  };

  // Sort divisionData alphabetically by divisionName
  const sortedData = [...divisionData].sort((a, b) =>
    a.divisionName.localeCompare(b.divisionName)
  );

  return (
    <div>
      <Modal
        show={show}
        onHide={onClose}
        size="md"
        aria-labelledby="example-modal-sizes-title-md"
      >
        <Modal.Header closeButton>
          <Modal.Title>{`Loan And Recovery for ${selectedCircle} Circle`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ResponsiveContainer width="100%" height={500}>
            <BarChart
              data={sortedData}
              margin={{ top: 20, right: 30, left: 10, bottom: 80 }}
              onClick={handleBarClick}
            >
              <XAxis
                dataKey="divisionName"
                angle={-45}
                textAnchor="end"
                interval={0}
                height={100}
                tickFormatter={(name) =>
                  name.length > 10 ? name.slice(0, 10) + "…" : name
                }
              />

              <YAxis tickFormatter={(value) => formatAmount(value)} />

              <Tooltip
                formatter={(value) => `₹${formatAmount(value)}`}
                labelFormatter={(label) => `Division: ${label}`}
              />
              <Legend />
              <Bar
                dataKey="totalLoanAmount"
                fill="#E74C3C"
                name="Loan Amount"
              />
              <Bar
                dataKey="totalRepaymentAmount"
                fill="#2ECC71"
                name="Recovered Amount"
              />
              <Bar
                dataKey="remainingAmount"
                fill="#F1C40F"
                name="Remaining Amount"
              />
            </BarChart>
          </ResponsiveContainer>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CircleModal;
